import React, { Component } from 'react';

const Sizer = (Comp) => {
	class SizerComp extends Component {
		state = {
			sizeSet: false,
			mobileWidth: ''
		}
		componentDidMount() {
			const winWidth = parseInt(window.innerWidth || 0),
				mobileWidth = (winWidth <= 768);

			this.setState({sizeSet: true, mobileWidth});
		}

		render () {
			const state = this.state;

			return (state.sizeSet ? <Comp {...{...this.props, mobileWidth: state.mobileWidth}} /> : null);
		}
	};

	return SizerComp;
}

export default Sizer;